import { TYPE_SIZES } from '../../utils/globalConst.js';

//
var script = {
  name: 'Counter',
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    size: {
      type: String,
      default: TYPE_SIZES.normal.value
    },
    values: {
      type: Number,
      default: 1
    },
    maxValue: {
      type: Number,
      default: 999
    },
    minValue: {
      type: Number,
      default: 0
    },
    isAllowZero: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function (vm) { return ({
    value: vm.values,
    focus: false
  }); },
  computed: {
    classes: function classes() {
      var obj;

      return ( obj = {}, obj[TYPE_SIZES.small.className] = this.size === TYPE_SIZES.small.value, obj[TYPE_SIZES.large.className] = this.size === TYPE_SIZES.large.value, obj );
    }

  },
  watch: {
    values: function values(value, oldValue) {
      if (value !== oldValue) {
        this.setValue(Number(value));
      }
    }

  },
  methods: {
    /**
     * Событие нажатия на кнопки
     * @param action
     */
    onAction: function onAction(action) {
      var value = this.value;

      switch (action) {
        case 'minus':
          {
            this.$emit('on-minus');
            this.setValue(value - 1);
            break;
          }

        case 'plus':
          {
            this.$emit('on-plus');
            this.setValue(value + 1);
            break;
          }
      }
    },

    /**
     * Событие ввода в инпут
     * @param target
     */
    onInput: function onInput(ref) {
      var target = ref.target;

      if (this.focus && target.value !== '') {
        this.setValue(Number(target.value));
      }
    },

    /**
     * Событие потери фокусса у инпута
     * @param data
     */
    onBlur: function onBlur(data) {
      this.$emit('on-blur', data);
      this.focus = false;

      if (data.target.value === '') {
        this.setValue(this.isAllowZero ? 0 : this.value);
      }
    },

    /**
     * Событие получения фокуса у инпута
     * @param data
     */
    onFocus: function onFocus(data) {
      this.$emit('on-focus', data);
      this.focus = true;
    },

    /**
     * Устанавливаем значение
     * @param value
     */
    setValue: function setValue(value) {
      if (value <= this.minValue) {
        this.value = value === 0 && this.isAllowZero ? 0 : this.minValue;
      } else if (value === 0 && this.isAllowZero) {
        this.value = 0;
      } else if (value >= this.maxValue) {
        this.value = this.maxValue;
      } else {
        this.value = value;
      }

      this.$emit('change', this.value);
    },

    /**
     * Запрещает ввод символов кроме цифр
     * @param event
     * @returns {boolean}
     */
    valueMask: function valueMask(event) {
      var k = event.which || event.button;
      if (event.ctrlKey && k === 86) { return false; }

      if (event.charCode && (event.charCode < 48 || event.charCode > 57)) {
        event.returnValue = false;
      }
    }

  }
};

export default script;
